var map = {
	"./198.doc": 429,
	"./210-сон.doc": 296,
	"./Действие общественно опасное.doc": 2411,
	"./ПЕРЕЧЕНЬ.doc": 3329,
	"./Статья 165м пр1.doc": 3181,
	"./Статья 183.doc": 2665,
	"./Статья 40.doc": 1841,
	"./Статья 41.doc": 1650,
	"./Статья 52.doc": 1309,
	"./уклонение налог.doc": 2949,
	"./чикар.doc": 7374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;